import * as React from 'react';
import moment from 'moment';

import type { EventElementProps } from './event-element-props.interface';

export const OwnerChange = ({ data }: EventElementProps) => (
  <div id={`OwnerChange-${data.id}`} className="owner-box">
    <div className="container">
      <div className="content">
        <div className="owner">
          <span>{data.preview}</span>
        </div>
        <div className="chat-timestamp">
          {moment(data.sent_at * 1000).format('L [AT] LT')}
        </div>
      </div>
    </div>
  </div>
);
